import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../common';
import { ICampaignBusinessScreensResponse, IResponseMessage } from '../../models';
import { IPlaylistResponse, IPlaylistAddResponse } from '../../models/playlist.model';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {

  constructor(private http: HttpClient) { }

  getCampaign(): Observable<IPlaylistResponse> {
    return this.http.get<IPlaylistResponse>(ApiConstants.campaign);
  }

  // getAllCampaigns(): Observable<IPlaylistResponse> {
  //   return this.http.get<IPlaylistResponse>(ApiConstants.campaign);
  // }

  // addCampaign(campaign: FormData): Observable<IPlaylistAddResponse> {
  //   return this.http.post<IPlaylistAddResponse>(ApiConstants.campaign, campaign);
  // }

  saveCampaign(campaign: FormData): Observable<IPlaylistAddResponse> {
    return this.http.post<IPlaylistAddResponse>(ApiConstants.campaign, campaign);
  }

  // deleteCampaignById(campaign_id: number): Observable<IResponseMessage> {
  //   return this.http.delete<IResponseMessage>(ApiConstants.campaign + campaign_id + '/');
  // }

  getAllBusinessScreens(): Observable<ICampaignBusinessScreensResponse[]> {
    return this.http.get<ICampaignBusinessScreensResponse[]>(ApiConstants.screens);
  }

}
